module.exports = __webpack_public_path__ + "static/img/fz_zzb_what.0c48cfd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_zzb_what.png
// module id = Ca5W
// module chunks = 0